import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BarController, Colors, Legend } from 'chart.js';

provideCharts({ registerables: [BarController, Legend, Colors] });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
